import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/InputGroup/input-group';
import { css } from '@patternfly/react-styles';
export var InputGroupText = function InputGroupText(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$component = _a.component,
      component = _a$component === void 0 ? 'span' : _a$component,
      children = _a.children,
      props = __rest(_a, ["className", "component", "children"]);

  var Component = component;
  return React.createElement(Component, Object.assign({
    className: css(styles.inputGroupText, className)
  }, props), children);
};